import { useMutation } from '@tanstack/react-query';
import { adminLogin } from '../services/auth';

export const useAdminLoginMutation = (options = {}) =>
  useMutation({
    mutationFn: async (credentials) => {
      const result = await adminLogin(credentials);
      if (!result.success) {
        throw new Error(result.message || 'Login failed');
      }
      return result;
    },
    ...options,
  });
